import { Component, OnInit } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { Persona } from 'se-resource-types/dist/lib/UserService'

const exampleHtml = `
<se-po-persona-avatar
  headerLink="#"
  [persona]="persona">
</se-po-persona-avatar>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { Persona } from 'se-resource-types/dist/lib/UserService'
export class PersonaAvatarLinkExampleComponent implements OnInit {
  public persona: Persona
  public ngOnInit(): void {
    this.persona = {
      id: 3,
      date_of_birth: '2019-12-11',
      first_name:'Senior',
      gender: 'female',
      last_name: 'Test'
    } as Persona
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-avatar-link-example',
  template,
  styleUrls: ['./../persona-avatar-docs.component.scss'],
  standalone: false,
})
export class PersonaAvatarLinkExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public persona: Persona

  public ngOnInit(): void {
    this.persona = {
      id: 3,
      date_of_birth: '2019-12-11',
      first_name:'Senior',
      gender: 'female',
      last_name: 'Test'
    } as Persona
  }
}
